import { render, staticRenderFns } from "./FocusArtists.vue?vue&type=template&id=3e3155d8&scoped=true&"
import script from "./FocusArtists.vue?vue&type=script&lang=ts&"
export * from "./FocusArtists.vue?vue&type=script&lang=ts&"
import style0 from "./FocusArtists.vue?vue&type=style&index=0&id=3e3155d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3155d8",
  null
  
)

export default component.exports